module.exports = __webpack_public_path__ + "img/bottom_bg.ff823008.png";